module.exports = __webpack_public_path__ + "static/media/icon_social-facebook.77379ede.svg";